import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import PatientDetails from "../../components/patient/PatientDetails";
import {
  fetchShiftPatientDetails,
  getBasicDetails,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
  getPatientById,
  getPatientCases,
  resetPatientToCasesMap,
  submitShiftPatientDetails,
  UpdatePatientDetails,
  updateSelectedPatient,
  updateShiftPatientDetails,
} from "../../models/patientSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { calculateAge } from "../../utils/globalUtils";
import { IAddCaseState, ICase, IDocumentFields } from "../../interfaces/ICase";
import {
  editCaseVisit,
  getCaseTypes,
  updateSelectedCase,
} from "../../models/casesSlice";
import { errorMessage, successMessage } from "../../utils/notificationUtils";
import {
  getPatientSchemes,
  selectedScheme,
  updatePatchPatientScheme,
} from "../../models/schemeSlice";
import { ROUTES } from "../../utils/constants";
import { IPatientScheme, ISchemeForm } from "../../interfaces/IScheme";
import { resetUpdateReferral } from "../../models/referralSlice";
import {
  downloadDocument,
  postShiftPatient,
  updatePatientDetail,
} from "../../apis/patientService";
import RightSidePreviewModal from "../../components/modals/RightSidePreviewModal";
import { getDoctors } from "../../models/doctorSlice";
import { IDoctorsState } from "../../interfaces/IDoctor";
import {
  fetchPreAuthStepper,
  getCreditNoteData,
  setCurrentStep,
  submitCreditNoteData,
} from "../../models/preAuthSlice";
import CreditNoteModal from "../../components/patient/BasicDetails/CreditNoteModal";
import CreditNoteModalPatient from "../../components/patient/BasicDetails/CreditNoteModalPatient";
import ShiftPatientModal from "../../components/patient/ShiftPatientModal";
import { Button, Flex } from "antd";
import {
  CloseCircleOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import EnhancementContainerIhx from "./Enhancement/IHX/EnhancementContainerIhx";
import QueryContainerIhx from "./Query/IHX/QueryContainerIhx";
import ViewEnhancementContainerIhx from "./Enhancement/IHX/ViewEnhancementContainerIhx";
import { fetchQueries, resetQueries } from "../../models/preAuthQuerySlice";
import EnhancementContainerCghs from "./Enhancement/CGHS/EnhancementContainerCghs";
import ViewEnhancementContainerCghs from "./Enhancement/CGHS/ViewEnhancementContainerCghs";
import EnhancementContainerCghsNew from "./Enhancement/CGHS/EnhancementContainerCghsNew";
import ViewEnhancementContainerCghsNew from "./Enhancement/CGHS/ViewEnhancementContainerCghsNew";
import ResubmissionContainerCghsNew from "./Resubmission/CGHS/ResubmissionContainerCghsNew";
import ResubmissionContainerCghs from "./Resubmission/CGHS/ResubmissionContainerCghs";
import ViewResubmissionContainerCghs from "./Resubmission/CGHS/ViewResubmissionContainerCghs";
import ViewResubmissionContainerCghsNew from "./Resubmission/CGHS/ViewResubmissionContainerCghsNew";
import UnlistedProcedureContainerEchs from "./Enhancement/ECHS/UnlistedProcedureContainerEchs";
import ViewUnlistedProcedureContainerEchs from "./Enhancement/ECHS/ViewUnlistedProcedureContainerEchs";
import ExtensionOfStayContainerEchs from "./Enhancement/ECHS/ExtensionOfStayContainerEchs";
import ViewExtensionOfStayContainerEchs from "./Enhancement/ECHS/ViewExtensionOfStayContainerEchs";
import NewExtensionOfStayContainer from "./Enhancement/ECHS/NewExtensionOfStayContainer";
import NewUnlistedProcedureContainer from "./Enhancement/ECHS/NewUnlistedProcedureContainer";

interface PatientContainerProps {
  flag: boolean;
  newSteps?: any;
}
const PatientDetailsContainer: FC<PatientContainerProps> = ({
  flag,
  newSteps,
}) => {
  const { patients, auth, scheme, hospital, doctor, preAuth, cases } =
    useSelector((state: RootState) => state);
  const navigate = useNavigate();

  const [readOnly, setReadOnly] = useState(true);
  const [isActiveDeactiveModal, setIsActiveDeactiveModal] =
    useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const path = location.pathname;
  // Get patientId from URL path
  const visitId = path.split("/")[3];
  const selectedHospital = hospital.selectedHospital;
  const [creditNoteModal, setCreditNoteModal] = useState<boolean>(false);
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  // const [isActiveDeactiveModal, setIsActiveDeactiveModal] = useState<boolean>(false);

  const [doctorOptions, setDoctorOptions] = useState<IDoctorsState[]>([]);
  const [isFetchingStepperData, setIsFetchingStepperData] =
    useState<boolean>(false);

  const [zoomLevel, setZoomLevel] = useState(1);
  const lastGetBasicDetailsKey = useRef<string | null>(null);
  const lastGetCaseTypesKey = useRef<string | null>(null);
  const lastShiftDetailsKey = useRef<string | null>(null);

  const getFileType = (url: any) => {
    const extension = url?.split(".").pop().toLowerCase(); // Get file extension
    if (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "gif"
    ) {
      return "image";
    } else if (extension === "pdf") {
      return "pdf";
    } else {
      return "unknown";
    }
  };

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 0.5));
  };

  const toggleReadOnly = () => {
    setReadOnly(!readOnly);
  };
  const upDateDetails = async (patientId: number, formValues: object) => {
    const resp = await dispatch(
      UpdatePatientDetails({
        id: patientId,
        formValues,
        accessToken: auth.accessToken || "",
      }),
    );
    if (UpdatePatientDetails.fulfilled.match(resp)) {
      toggleReadOnly();
      successMessage("UPDATE PATIENT SUCCESSFULLY");

      if (resp.payload.patient) {
        dispatch(updateSelectedPatient(resp.payload.patient));
        dispatch(resetPatientToCasesMap());
        dispatch(
          getBasicDetails({
            id: parseInt(visitId),
          }),
        );
      }
    } else if (UpdatePatientDetails.rejected.match(resp)) {
      errorMessage("Failed to update patient");
    }
  };

  const handleCaseSelect = (record: IAddCaseState) => {
    dispatch(updateSelectedCase(record));
    dispatch(resetUpdateReferral());
  };

  const clearReferralDetails = () => {
    dispatch(resetUpdateReferral());
  };

  const handleActivateDeactivate = () => {
    setIsActiveDeactiveModal(true);
  };

  const handleEditVisitData = async (
    caseId: string,
    visitId: string,
    status: boolean,
  ) => {
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      const resp = await dispatch(
        editCaseVisit({
          id: parseInt(caseId),
          visitId: parseInt(visitId),
          formValues: {
            ...patients?.fetchBasicDetails?.visitInfoResponse,
            status: status,
            patientId: patients?.fetchBasicDetails?.patientResponse?.id,
          },
        }),
      );

      if (editCaseVisit.fulfilled.match(resp)) {
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          await dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
        setIsActiveDeactiveModal(false);
        successMessage("CASE STATUS UPDATED SUCCESSFULLY!");
      } else if (editCaseVisit.rejected.match(resp)) {
        errorMessage("CASE STATUS CANT'T UPDATE DUE TO INTERNAL SERVER");
      }
    }
  };

  const handleOKActiveDeactiveModal = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      handleEditVisitData(
        patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        !patients?.fetchBasicDetails?.visitInfoResponse?.status,
      );
    }
  };
  const handleCancelActiveDeactiveModal = () => {
    setIsActiveDeactiveModal(false);
  };

  const [justify, setJustify] = useState<string>("");

  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 1200) {
      // adjust the value as per your requirement
      setJustify("space-evenly");
    } else {
      setJustify("space-between");
    }
  };

  useEffect(() => {
    handleResize(); // set the initial value
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // If we directly land on details screen patient state will not have selectedPatient
  // useEffect(() => {
  //   // if (patients.selectedPatient === null) {
  //   //   dispatch(
  //   //     getPatientById({
  //   //       id: parseInt(patientId),
  //   //       accessToken: auth.accessToken || "",
  //   //     })
  //   //   );
  //   //   dispatch(
  //   //     getPatientCases({
  //   //       id: parseInt(patientId),
  //   //       accessToken: auth.accessToken || "",
  //   //     })
  //   //   );
  //   // }
  //   if (visitId) {
  //     dispatch(
  //       getBasicDetails({
  //         id: parseInt(visitId),
  //       }),
  //     );
  //   }
  //   // dispatch(
  //   //   getPatientCases({
  //   //     id: parseInt(patientId),
  //   //     accessToken: auth.accessToken || "",
  //   //   })
  //   // );
  // }, [visitId]);

  useEffect(() => {
    setDoctorOptions(doctor?.availableDoctor || []);
  }, [doctor?.availableDoctor]);

  const handleCreditClickModal = () => {
    setCreditNoteModal(true);
  };

  // Fetch patient cases and schemes
  // useEffect(() => {
  //   if (
  //     patients.patientToCasesMap &&
  //     !(parseInt(patientId) in patients.patientToCasesMap)
  //     // && patients.selectedPatient &&
  //     // patients.selectedPatient.id
  //   ) {
  //     dispatch(
  //       getPatientCases({
  //         id: parseInt(patientId), //patients.selectedPatient.id
  //         accessToken: auth.accessToken || "",
  //       })
  //     );
  //   }

  //   if (!scheme.patientSchemesList[parseInt(patientId)]) {
  //     dispatch(
  //       getPatientSchemes({
  //         id: parseInt(patientId),
  //         accessToken: auth.accessToken || "",
  //       })
  //     );
  //   }
  // }, [patientId, patients.selectedPatient]);

  const handleEditClick = (index: number, item: IPatientScheme) => {
    dispatch(selectedScheme(item?.schemeId + " " + item?.schemeName));
    navigate({
      pathname: `${ROUTES.ADD_PATIENT_SCHEME}/${patients?.fetchBasicDetails?.patientResponse?.id}/${item?.id}`,
    });
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded successfully");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      setIsDownloadingDocument(false);
    }
  };

  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null,
  ); //to send document id for deficiency check
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields,
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  // useEffect(() => {
  //   const fetchDeficiencyData = async () => {
  //     try {
  //       if(selectedDocumentId) {
  //         const res = await dispatch(getDeficiencyQuestions(selectedDocumentId));
  //       }
  //       // if(true) {
  //       //   const res = await dispatch(getDeficiencyQuestions(874));
  //       // }
  //     }
  //     catch(err) {
  //       errorMessage("Please, Try again after sometime");
  //       setSelectedDocumentId(null);
  //       setSelectedDocument(null);
  //     }
  //   }

  //   if(selectedDocumentId) fetchDeficiencyData();
  //   // if(true) fetchDeficiencyData();
  // }, [selectedDocumentId])

  useEffect(() => {
    const fetchDeficiencyData = async () => {
      try {
        if (selectedDocument?.id) {
          const res = await dispatch(
            getDeficiencyQuestionData(selectedDocument?.id),
          );
        }
        // if(true) {
        //   const res = await dispatch(getDeficiencyQuestions(874));
        // }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };
    fetchDeficiencyData();
  }, [selectedDocument]);

  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentUrl, setDocumentUrl] = useState<string>("");

  const handleOpen = (url: string) => {
    setDocumentUrl(url);
    setPreviewDocument(true);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const showDoc = (file: string) => {
    if (!file) {
      errorMessage("No Document Present");
      return;
    }
    setDocumentUrl(file);
    setPreviewDocument(true);
  };

  const handleDoctorSearch = async (value: string) => {
    if (value) {
      dispatch(
        getDoctors({
          search: value,
          accessToken: auth.accessToken || "",
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        }),
      );
    }
  };

  const handleNavigate = (string: any) => {
    navigate(string);
    dispatch(resetUpdateReferral());
    dispatch(setCurrentStep(0));
  };

  useEffect(() => {
    if (creditNoteModal && patients.fetchBasicDetails?.visitInfoResponse?.id) {
      dispatch(
        getCreditNoteData({
          visitId: patients.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  }, [creditNoteModal, patients.fetchBasicDetails?.visitInfoResponse?.id]);

  const handleSubmitCreditNote = async (values: any) => {
    if (patients.fetchBasicDetails?.visitInfoResponse?.id) {
      const resp = await dispatch(
        submitCreditNoteData({
          visitId: patients.fetchBasicDetails?.visitInfoResponse?.id,
          formData: values,
        }),
      );

      if (submitCreditNoteData.fulfilled.match(resp)) {
        successMessage("Updated Successfully");
      } else if (submitCreditNoteData.rejected.match(resp)) {
        errorMessage(
          "Can not Update Credit Note. Please, Try again after sometime",
        );
      }
    }
  };

  const handleCancel = () => {
    setCreditNoteModal(false);
  };

  const handleUpdatePatientScheme = async (values: any) => {
    if (values?.schemeUpdateId) {
      const resp = await dispatch(
        updatePatchPatientScheme({
          accessToken: auth.accessToken || "",
          patientId: values?.patientId,
          schemeId: values?.schemeMetaDataId,
          id: values?.schemeUpdateId,
          formData: {
            status: values?.status,
            schemePolicyNumber: values?.schemePolicyNumber,
          },
        }),
      );
      if (updatePatchPatientScheme.fulfilled.match(resp)) {
        successMessage(`PATIENT SCHEME HAS BEEN UPDATED SUCCESSFULLY`);
        if (patients?.fetchBasicDetails?.patientResponse?.id) {
          await dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } else if (updatePatchPatientScheme.rejected.match(resp)) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  const handleUpdatePatientDetails = async (formData: any) => {
    try {
      const res = await updatePatientDetail(formData);
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        await dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }

      successMessage("Visit and Referral Details Updated Successfully");
    } catch (err) {
      console.error(err);
      errorMessage("Please, Try again after sometime");
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    const getShiftPatientData = async () => {
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      if (caseId && visitId) {
        const requestKey = `${isModalVisible ? 1 : 0}_${caseId}_${visitId}`;
        if (isModalVisible && lastShiftDetailsKey.current !== requestKey) {
          lastShiftDetailsKey.current = requestKey;
          await dispatch(
            fetchShiftPatientDetails({
              caseId,
              visitId,
            }),
          );
        }
      }
    };
    if (isModalVisible) getShiftPatientData();
  }, [patients?.fetchBasicDetails, isModalVisible]);

  const handleSubmitShiftPatient = async (formData: any) => {
    try {
      const res = await dispatch(submitShiftPatientDetails(formData));
      if (submitShiftPatientDetails.fulfilled.match(res)) {
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          setIsModalOpen(false);
          await dispatch(
            fetchShiftPatientDetails({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
          successMessage("Shift Details Changed Successfully");
        }
      } else if (submitShiftPatientDetails.rejected.match(res)) {
        errorMessage("Please, Try again later");
        setIsModalOpen(false);
      }
    } catch (err) {
      console.error(err);
      setIsModalOpen(false);
    }
  };

  const handleUpdateShiftPatient = async (
    formData: any,
    visitShiftId: number,
  ) => {
    try {
      const res = await dispatch(
        updateShiftPatientDetails({ formData, visitShiftId }),
      );
      if (updateShiftPatientDetails.fulfilled.match(res)) {
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          await dispatch(
            fetchShiftPatientDetails({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
          successMessage("Shift details edited successfully");
        }
      } else if (updateShiftPatientDetails.rejected.match(res)) {
        errorMessage("Please, Try again later");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //to check whether confirmation modal is open or not
  const [submittedPatientShiftDetails, setSubmittedPatientShiftDetails] =
    useState<any>(null);

  const handleShowConfirmPopUp = (values: any) => {
    setSubmittedPatientShiftDetails(values);
    setIsModalOpen(!isModalOpen);
  };

  const handleOkConfirmationModal = () => {
    handleSubmitShiftPatient(submittedPatientShiftDetails);
    // handleCloseModal();
  };

  const handleCancelConfirmationModal = () => {
    setIsModalOpen(!isModalOpen);
    handleCloseModal();
  };
  const [activeStage, setActiveStage] = useState<any>();

  // useEffect(() => {
  // if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
  // dispatch(
  //   getCaseTypes({
  //     accessToken: auth.accessToken || "",
  //     schemeId:
  //       patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  //   })
  // );
  // }

  //   if (
  //     patients?.fetchBasicDetails?.casesResponse?.id &&
  //     patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds &&
  //     patients?.fetchBasicDetails?.visitInfoResponse?.id &&
  //     activeStage
  //   ) {
  //     dispatch(
  //       fetchQueries({
  //         caseId: patients?.fetchBasicDetails?.casesResponse?.id,
  //         visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //         portalMetaDataId:
  //           patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
  //         stageId: parseInt(activeStage),
  //       }),
  //     );
  //   }
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  //   activeStage,
  //   preAuth?.stepperData?.currentVisitStage?.visitStageId,
  // ]);

  useEffect(() => {
    const schemeId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
    if (schemeId) {
      const requestKey = `${schemeId}_${auth.accessToken}`;
      if (lastGetCaseTypesKey.current !== requestKey) {
        lastGetCaseTypesKey.current = requestKey;
        dispatch(
          getCaseTypes({
            accessToken: auth.accessToken || "",
            schemeId,
          }),
        );
      }
    }
  }, [
    auth.accessToken,
    dispatch,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  ]);

  useEffect(() => {
    dispatch(resetQueries());
  }, [activeStage, visitId]);

  const fetchStepper = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      setIsFetchingStepperData(true);
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      await dispatch(fetchPreAuthStepper({ caseId: caseId, visitId: visitId }));
      setIsFetchingStepperData(false);
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      fetchStepper();
    }
  }, [patients?.fetchBasicDetails?.visitInfoResponse?.id]);

  const [createEnhancement, setCreateEnhancement] = useState<boolean>(false);
  const [createQuery, setCreateQuery] = useState<boolean>(false);

  const [createEnhancementCghs, setCreateEnhancementCghs] =
    useState<boolean>(false);

  const [createUnlistedProcedureEchs, setCreateUnlistedProcedureEchs] =
    useState<boolean>(false);
  const [viewUnlistedProcedureEchs, setViewUnlistedProcedureEchs] =
    useState<boolean>(false);

  const [createExtensionOfStayEchs, setCreateExtensionOfStayEchs] =
    useState<boolean>(false);
  const [viewExtensionOfStayEchs, setViewExtensionOfStayEchs] =
    useState<boolean>(false);

  const [viewEnhancement, setViewEnhancement] = useState<boolean>(false);
  const [viewEnhancementCghs, setViewEnhancementCghs] =
    useState<boolean>(false);
  const [resubmissionCghs, setResubmissionCghs] = useState<boolean>(false);
  const [viewResubmissionCghs, setViewResubmissionCghs] =
    useState<boolean>(false);

  const handleCreateEnhancement = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setCreateEnhancementCghs(true);
    } else {
      setCreateEnhancement(true);
    }
  };

  useEffect(() => {
    if (!createUnlistedProcedureEchs && !createExtensionOfStayEchs && visitId) {
      dispatch(
        getBasicDetails({
          id: parseInt(visitId),
        }),
      );
    }
  }, [
    createUnlistedProcedureEchs,
    createExtensionOfStayEchs,
    visitId,
  ]);

  const handleResubmission = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setResubmissionCghs(true);
    }
  };

  const handleCreateQuery = (stageId: string) => {
    setCreateQuery(true);
    setActiveStage(stageId);
  };

  const viewAddedEnhancement = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setViewEnhancementCghs(true);
    } else {
      setViewEnhancement(true);
    }
  };

  const viewResubmission = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setViewResubmissionCghs(true);
    }
  };

  const closeCreateEnhancementModal = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setCreateEnhancementCghs(false);
    } else {
      setCreateEnhancement(false);
    }
  };

  const closeViewAddedEnhancement = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setViewEnhancementCghs(false);
    } else {
      setViewEnhancement(false);
    }
  };

  const closeViewResubmissionModal = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setViewResubmissionCghs(false);
    }
  };

  const closeResubmissionCghsModal = () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" ||
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS AB"
    ) {
      setResubmissionCghs(false);
    }
  };

  const closeCreateQueryModal = () => {
    setCreateQuery(false);
  };

  const handleSetActiveStage = (stage: any) => {
    setActiveStage(stage);
  };

  const handleCreateUnlistedProcedure = () => {
    setCreateUnlistedProcedureEchs(true);
  };

  const handleCreateExtensionOfStay = () => {
    setCreateExtensionOfStayEchs(true);
  };

  const closeCreateUnlistedProcedure = () => {
    setCreateUnlistedProcedureEchs(false);
  };

  const closeCreateExtensionOfStayEchs = () => {
    setCreateExtensionOfStayEchs(false);
  };

  const viewUnlistedProcedure = () => {
    setViewUnlistedProcedureEchs(true);
  };

  const viewExtensionOfStay = () => {
    setViewExtensionOfStayEchs(true);
  };

  const closeViewUnlistedProcedure = () => {
    setViewUnlistedProcedureEchs(false);
  };

  const closeViewExtensionOfStayEchs = () => {
    setViewExtensionOfStayEchs(false);
  };

  useEffect(() => {
    if (!activeStage) {
      setActiveStage(
        preAuth?.stepperData?.currentVisitStage?.visitStageId?.toString(),
      );
    }
  }, [preAuth?.stepperData?.currentVisitStage?.visitStageId]);

  return (
    <>
      <PatientDetails
        flag={flag}
        patientCases={
          patients.selectedPatient &&
          patients.patientToCasesMap &&
          patients.selectedPatient.id
            ? patients.patientToCasesMap[patients.selectedPatient.id]
            : []
        }
        patientSchemes={[]}
        onTabChange={(activeKey: string) => {
          console.log(activeKey);
        }}
        isFetchingPatient={patients.isFetchingPatientById}
        error={patients.error}
        selectedPatient={patients.fetchBasicDetails}
        readOnly={readOnly}
        toggleReadOnly={toggleReadOnly}
        upDateDetails={upDateDetails}
        calculateAge={calculateAge}
        handleCaseSelect={handleCaseSelect}
        selectedHospital={selectedHospital}
        isLoading={patients?.isLoading}
        justify={justify}
        handleEditClick={handleEditClick}
        clearReferralDetails={clearReferralDetails}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        previewDocumentUrl={previewDocumentUrl}
        handleOpen={handleOpen}
        showDoc={showDoc}
        handleDoctorSearch={handleDoctorSearch}
        availableDoctor={doctorOptions}
        searchLoading={doctor?.isLoading}
        handleNavigate={handleNavigate}
        handleCreditClickModal={handleCreditClickModal}
        handleUpdatePatientScheme={handleUpdatePatientScheme}
        handleUpdatePatientDetails={handleUpdatePatientDetails}
        setPreviewDocument={setPreviewDocument}
        previewDocument={previewDocument}
        showModal={showModal}
        documentUrl={documentUrl}
        zoomLevel={zoomLevel}
        handleZoomIn={handleZoomIn}
        handleZoomOut={handleZoomOut}
        handleCancelPreview={handleCancelPreview}
        getFileType={getFileType}
        fetchStepper={fetchStepper}
        handleActivateDeactivate={handleActivateDeactivate}
        isActiveDeactiveModal={isActiveDeactiveModal}
        setIsActiveDeactiveModal={setIsActiveDeactiveModal}
        handleOk={handleOKActiveDeactiveModal}
        handleCancelConfirmationModal={handleCancelActiveDeactiveModal}
        isSubmitting={cases?.isLoading}
        newSteps={preAuth?.stepperData}
        handleCreateEnhancement={handleCreateEnhancement}
        handleCreateQuery={handleCreateQuery}
        viewAddedEnhancement={viewAddedEnhancement}
        handleSetActiveStage={handleSetActiveStage}
        isFetchingStepperData={isFetchingStepperData}
        handleResubmission={handleResubmission}
        viewResubmission={viewResubmission}
        handleCreateUnlistedProcedure={handleCreateUnlistedProcedure}
        handleCreateExtensionOfStay={handleCreateExtensionOfStay}
        viewUnlistedProcedure={viewUnlistedProcedure}
        viewExtensionOfStay={viewExtensionOfStay}
      />
      <CreditNoteModal
        fetchPatientDetail={patients?.selectedPatient || null}
        fetchAllPatientDetails={patients?.fetchBasicDetails}
        creditNoteModal={creditNoteModal}
        handleCancel={handleCancel}
        creditNoteData={preAuth?.creditNoteData}
        handleSubmitCreditNote={handleSubmitCreditNote}
        isLoading={preAuth?.isFetchingPortalData}
        handleDownloadDocument={handleDownloadDocument}
      />

      {isModalVisible ? (
        <ShiftPatientModal
          isModalVisible={isModalVisible}
          handleCloseModal={handleCloseModal}
          shiftPatientData={patients?.shiftPatientData}
          handleOk={handleOkConfirmationModal}
          handleShowConfirmPopUp={handleShowConfirmPopUp}
          handleCancelConfirmationModal={handleCancelConfirmationModal}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          isSubmitting={patients?.isLoading}
          selectedPatient={patients?.fetchBasicDetails}
          casesType={cases?.caseType}
          handleUpdateShiftPatient={handleUpdateShiftPatient}
        />
      ) : (
        <></>
      )}

      {createEnhancement ? (
        <EnhancementContainerIhx
          createEnhancement={createEnhancement}
          closeCreateEnhancementModal={closeCreateEnhancementModal}
          activeKey={activeStage}
        />
      ) : (
        <></>
      )}

      {viewEnhancement ? (
        <ViewEnhancementContainerIhx
          viewEnhancement={viewEnhancement}
          closeViewAddedEnhancement={closeViewAddedEnhancement}
        />
      ) : (
        <></>
      )}

      {createEnhancementCghs ? (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
          "CGHS" && createEnhancementCghs ? (
          <EnhancementContainerCghs
            createEnhancement={createEnhancementCghs}
            closeCreateEnhancementModal={closeCreateEnhancementModal}
            activeKey={activeStage}
          />
        ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
            "CGHS AB" && createEnhancementCghs ? (
          <EnhancementContainerCghsNew
            createEnhancement={createEnhancementCghs}
            closeCreateEnhancementModal={closeCreateEnhancementModal}
            activeKey={activeStage}
          />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}

      {createUnlistedProcedureEchs ? (
        <NewUnlistedProcedureContainer
          visible={createUnlistedProcedureEchs}
          onCancel={closeCreateUnlistedProcedure}
          activeKey={activeStage}
        />
      ) : (
        // <UnlistedProcedureContainerEchs
        //   createUnlistedProcedureEchs={createUnlistedProcedureEchs}
        //   closeCreateUnlistedProcedure={closeCreateUnlistedProcedure}
        //   activeKey={activeStage}
        // />
        <></>
      )}

      {createExtensionOfStayEchs ? (
        <NewExtensionOfStayContainer
          visible={createExtensionOfStayEchs}
          onCancel={closeCreateExtensionOfStayEchs}
          activeKey={activeStage}
        />
      ) : (
        // <ExtensionOfStayContainerEchs
        //   createExtensionOfStayEchs={createExtensionOfStayEchs}
        //   closeCreateExtensionOfStayEchs={closeCreateExtensionOfStayEchs}
        //   activeKey={activeStage}
        // />
        <></>
      )}

      {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" && viewEnhancementCghs ? (
        <ViewEnhancementContainerCghs
          viewEnhancement={viewEnhancementCghs}
          closeViewAddedEnhancement={closeViewAddedEnhancement}
        />
      ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
          "CGHS AB" && viewEnhancementCghs ? (
        <ViewEnhancementContainerCghsNew
          viewEnhancement={viewEnhancementCghs}
          closeViewAddedEnhancement={closeViewAddedEnhancement}
        />
      ) : (
        <></>
      )}

      {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "ECHS" && viewUnlistedProcedureEchs ? (
        <ViewUnlistedProcedureContainerEchs
          viewUnlistedProcedureEchs={viewUnlistedProcedureEchs}
          closeViewUnlistedProcedure={closeViewUnlistedProcedure}
        />
      ) : (
        <></>
      )}

      {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "ECHS" && viewExtensionOfStayEchs ? (
        <ViewExtensionOfStayContainerEchs
          viewEnhancement={viewExtensionOfStayEchs}
          closeViewAddedEnhancement={closeViewExtensionOfStayEchs}
        />
      ) : (
        <></>
      )}

      {resubmissionCghs ? (
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
          "CGHS" && resubmissionCghs ? (
          <ResubmissionContainerCghs
            resubmissionCghs={resubmissionCghs}
            closeResubmissionCghsModal={closeResubmissionCghsModal}
            activeKey={activeStage}
          />
        ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
            "CGHS AB" && resubmissionCghs ? (
          <ResubmissionContainerCghsNew
            resubmissionCghs={resubmissionCghs}
            closeResubmissionCghsModal={closeResubmissionCghsModal}
            activeKey={activeStage}
          />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}

      {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
        "CGHS" && viewResubmissionCghs ? (
        <ViewResubmissionContainerCghs
          viewResubmissionCghs={viewResubmissionCghs}
          closeViewResubmissionModal={closeViewResubmissionModal}
        />
      ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
          "CGHS AB" &&
        viewResubmissionCghs ? //   viewResubmissionCghs={viewResubmissionCghs} // <ViewResubmissionContainerCghsNew
      //   closeViewResubmissionModal={closeViewResubmissionModal}
      // />
      null : (
        <></>
      )}

      {createQuery ? (
        <QueryContainerIhx
          createQuery={createQuery}
          closeCreateQueryModal={closeCreateQueryModal}
          activeStage={activeStage}
        />
      ) : (
        <></>
      )}

      {/* <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      /> */}

      {/* {previewDocument && previewDocument && (
            <Flex vertical style={{ width: "55%" }}>
              <div
                style={{
                  marginBottom: "1rem",
                  marginLeft: "3px",
                  marginTop: "37px",
                }}
              >
                {getFileType(documentUrl) == "image" ? (
                  <>
                    <Button
                      onClick={(event) => handleZoomOut()}
                      disabled={zoomLevel <= 0.5}
                      style={{ marginRight: "0.5rem" }}
                    >
                      <ZoomOutOutlined />
                    </Button>
                    <Button
                      onClick={(event) => handleZoomIn()}
                      disabled={zoomLevel >= 3}
                    >
                      <ZoomInOutlined />
                    </Button>
                  </>
                ) : (
                  ""
                )}
                <Button
                  shape="circle"
                  icon={<CloseCircleOutlined />}
                  onClick={() => handleCancelPreview()}
                  style={{ float: "right" }}
                />
              </div>
              {getFileType(documentUrl) == "image" ? (
                <div
                  style={{
                    width: "100%",
                    overflowX: "scroll",
                    // transform: "rotate(180deg)",
                    border: "2px solid rgb(175, 175, 175)",
                    borderRadius: "8px",
                    padding: ".4rem",
                  }}
                >
                  <img
                    src={documentUrl}
                    // type="application/pdf"
                    width="100%"
                    // height="100%"
                    style={{
                      transform: `scale(${zoomLevel})`,
                      transformOrigin: "center",
                      transition: "transform 0.3s ease",
                      overflow: "auto",
                      marginLeft: "1rem",
                      marginTop: "17rem",
                    }}
                  />
                </div>
              ) : (
                <embed
                  src={documentUrl}
                  type="application/pdf"
                  width="100%"
                  height="984px"
                  style={{
                    border: "2px solid rgb(175, 175, 175)",
                    borderRadius: "8px",
                    padding: "2rem",
                    marginLeft: "0.5rem",
                  }}
                />
              )}
            </Flex>
          )} */}
    </>
  );
};

export default PatientDetailsContainer;
